// frontend/src/utils/emailPolicy.ts
// Mirrors backend/services/user_service/email_policy.py. Plus-addressed emails
// (me+tag@domain) never get an account: every +tag reaches the same mailbox, so
// one person could mint unlimited accounts. The backend gate is authoritative;
// this check only spares honest users a sign-in code that can't lead anywhere.

export const PLUS_ADDRESS_MESSAGE =
  'Addresses with a +tag aren’t supported. Use your plain email address.';

export function hasPlusTag(email: string | null | undefined): boolean {
  const trimmed = (email ?? '').trim();
  const at = trimmed.lastIndexOf('@');
  return at >= 0 && trimmed.slice(0, at).includes('+');
}
